import { MenuItem, useToast } from '@morressier/alembic';
import { useCallback, useState } from 'react';
import { IPermission } from '@publishing-engine/domain/models';

import { useUpdateWorkspaceRole } from 'src/api/mutations';
import { useWorkspace } from '../../SubmissionContexts/Users/userHook';
import { RoleForm } from './RoleForm';
import { IRolePayload } from './roleFormSchema';

type updateRoleProps = {
  name: string;
  permission: IPermission;
  displayName?: string;
};

type UpdateRoleFormProps = {
  name: string;
  displayName: string;
  permission: IPermission;
  workspaceId: string;
  onClose: () => void;
};

const UpdateRoleForm = ({
  name,
  displayName,
  permission,
  workspaceId,
  onClose
}: UpdateRoleFormProps) => {
  const toast = useToast();

  const updateRoleMutation = useUpdateWorkspaceRole(workspaceId, name);

  const handleSubmit = async ({
    displayName: newDisplayName,
    permissions
  }: IRolePayload) => {
    const res = await updateRoleMutation.mutateAsync({
      name,
      displayName: newDisplayName,
      permissions
    });

    if (res.isSuccess) {
      toast({
        variant: 'success',
        title: 'Role Update',
        isClosable: true
      });
    } else {
      toast({
        variant: 'error',
        title: res.message,
        isClosable: true
      });
    }

    onClose();
  };

  return (
    <RoleForm
      workspaceId={workspaceId}
      title="Update Role"
      submitLabel="Update Role"
      defaultValues={{
        name,
        displayName,
        permissions: permission,
        permissionsGroup: permission
      }}
      onSubmit={handleSubmit}
      onCancel={onClose}
      isNameReadOnly
    />
  );
};

const UpdateRole = ({ permission, displayName, name }: updateRoleProps) => {
  const [edit, setEdit] = useState(false);

  const { workspaceId } = useWorkspace();

  const handleOpen = useCallback(() => {
    setEdit(true);
  }, []);

  const handleClose = useCallback(() => {
    setEdit(false);
  }, []);

  return (
    <>
      <MenuItem ariaLabel="Edit-role" onClick={handleOpen}>
        Edit
      </MenuItem>
      {edit && (
        <UpdateRoleForm
          name={name}
          displayName={displayName ?? name}
          permission={permission}
          workspaceId={workspaceId}
          onClose={handleClose}
        />
      )}
    </>
  );
};

export default UpdateRole;
